@if (hasAccess) {
  <div class="padding">
    <h1 class="left-box">{{fullName}}</h1>
    @if (reusableParty) {
      <mat-card>
        <mat-card-content>
          <div class="flex-container">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>{{ 'common.labels.partyType' | transloco }}</mat-label>
              <mat-select [(ngModel)]="this.reusableParty.partyTypeID" [disabled]="!isEditable">
                @for (partyType of partyTypes; track partyType) {
                  <mat-option [value]="partyType.value">
                    {{ partyType.label | transloco }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            @if (!isBusiness()) {
              <div>
                <mat-checkbox [(ngModel)]="this.reusableParty.isEstate" style="margin-left: 1em;"
                  name="is-estate">
                  {{ 'common.labels.estate' | transloco }}
                </mat-checkbox>
              </div>
            }
            <mat-checkbox [(ngModel)]="this.reusableParty!.isVisible" [disabled]="!isEditable"
            style="margin-left: 1em; margin-right: 0.5em;">{{ 'common.labels.active' | transloco }}</mat-checkbox>
          </div>
          <div class="flex-container">
            @if (isBusiness()) {
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{ 'common.labels.name' | transloco }}</mat-label>
                <input matInput name="name" [(ngModel)]="this.reusableParty.busName" [disabled]="!isEditable"
                  [placeholder]="'common.labels.name' | transloco">
              </mat-form-field>
            } @else {
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{ 'common.labels.firstName' | transloco }}</mat-label>
                <input matInput name="name" [(ngModel)]="this.reusableParty.firstName"
                  [disabled]="!isEditable" [placeholder]="'common.labels.name' | transloco">
              </mat-form-field>
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{ 'common.labels.middleName' | transloco }}</mat-label>
                <input matInput name="name" [(ngModel)]="this.reusableParty.middleName"
                  [disabled]="!isEditable" [placeholder]="'common.labels.name' | transloco">
              </mat-form-field>
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{ 'common.labels.lastName' | transloco }}</mat-label>
                <input matInput name="name" [(ngModel)]="this.reusableParty.lastName" [disabled]="!isEditable"
                  [placeholder]="'common.labels.name' | transloco">
              </mat-form-field>
            }
          </div>
          <app-client-contact-details-card [contactDetails]="reusableParty.contactDetails!"
          [enabled]="isEditable"></app-client-contact-details-card>
          @if (isEditable) {
            <div class="flex-container">
              <button
                mat-raised-button
                (click)="cancel()"
                class="apply-padding"
                [attr.aria-label]="'common.labels.cancelButton' | transloco"
                [class.spinner]="this.isEditing"
                [disabled]="this.isEditing">
                {{ 'common.buttons.cancel' | transloco }}
              </button>
              <span class="spacer"></span>
              <button mat-raised-button (click)="updateReusableParty()" color="accent" class="apply-padding"
                [attr.aria-label]="'common.labels.saveBillingDetailsButton' | transloco" [class.spinner]="this.isEditing"
                [disabled]="this.isEditing">
                {{ 'common.buttons.save' | transloco }}
              </button>
            </div>
          } @else {
            <h3>{{ 'common.labels.registryCodes' | transloco }}</h3>
            <table mat-table [dataSource]="this.reusableParty.reusablePartyCodes!">
              <ng-container matColumnDef="country">
                <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.country' | transloco }} </th>
                <td mat-cell *matCellDef="let party"> {{party.country}} </td>
              </ng-container>
              <ng-container matColumnDef="jurisdiction">
                <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.jurisdiction' | transloco }} </th>
                <td mat-cell *matCellDef="let party"> {{party.jurisdiction}} </td>
              </ng-container>
              <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.registryCode' | transloco }} </th>
                <td mat-cell *matCellDef="let party"> {{party.code}} </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedPartyCodeColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedPartyCodeColumns;"></tr>
            </table>
          }
        </mat-card-content>
      </mat-card>
    }
  </div>
}